module.exports = __webpack_public_path__ + "img/ic-lock.fd0f1b04.svg";